// @flow

import { Badge, Tooltip } from "antd";
import { BotView, DateView, TopView, Wrapper } from "./MiniCard.styles";
import { Image } from "../common";
import { Link } from "react-router-dom";
import { formatDatetime } from "lib/date";
import { join, pathOr } from "ramda";
import { selectLineById } from "../../../../state/lines/selectors";
import { useOffice } from "../../../../state/offices/hooks";
import Info from "./Info";
import React, { useGlobal } from "reactn";
import logos from "views/resources/logos/SVG";

export const MiniReservationCard = ({ reservation }) => {
	const {
		lineName,
		officeName,
		office: officeSlug,
		categoryId,
		from,
		code,
		confirmed,
		line_id: lineId = null,
	} = reservation;

	const [office, officeLoading] = useOffice(officeSlug);

	const appointmentDate =
		!!office && !officeLoading && formatDatetime(from, office.timezone);

	const path = join("/");
	const [lines] = useGlobal("linesv2");
	const { slug: lineSlug } = selectLineById(lines, lineId);

	const logo = pathOr(false, ["options", "brand", "logo"], office);
	const showLogo = pathOr(false, ["options", "brand", "show_logo"], office);

	return (
		!officeLoading && (
			<Link
				to={
					"/" +
					path([
						"reserve",
						reservation.office,
						reservation.line || lineSlug,
						reservation.id,
					])
				}
			>
				<Wrapper notification={false}>
					<TopView>
						<Image>
							<img
								src={
									showLogo
										? logo
										: logos[`logo_${categoryId}_color`]
								}
							/>
						</Image>
						<h4>{officeName}</h4>
						<Tooltip
							title={
								confirmed ? "Confirmada" : "Por confirmar..."
							}
						>
							<Badge status={confirmed ? "success" : "warning"} />
						</Tooltip>
					</TopView>
					<BotView>
						<Info
							title="Número de Reserva:"
							body={code}
							position="left"
						/>
						<Info
							title="Nombre de fila:"
							body={lineName}
							position="right"
						/>
					</BotView>
					<DateView>
						<h4 className="title">Fecha de compromiso: </h4>
						<h5 className="body">{appointmentDate}</h5>
					</DateView>
				</Wrapper>
			</Link>
		)
	);
};
